import { DISCONNECT_CLICK } from '../../../store/constants/analytics';
import {
  DISCONNECTED_FOR_INACTIVITY_DIALOG,
  LOW_BALANCE_DIALOG,
  TABLE_CLOSED_DIALOG,
  NO_VIDEO_DIALOG,
  VIDEO_ERROR_DIALOG,
  DISCONNECTED_SESSION_DIALOG,
} from '../../../store/constants/dialog';
import { disconnectedForInactivityIntlKeys } from '../dialogs/DisconnectedForInactivity';
import { lowBalanceIntlKeys } from '../dialogs/LowBalance';
import { noVideoIntlKeys } from '../dialogs/NoVideo';
import { tableClosedIntlKeys } from '../dialogs/TableClosed';
import { videoErrorIntlKeys } from '../dialogs/VideoError';

const homeButton = { action: 'home', intlKey: 'general.home', primary: false };
const refreshButton = { action: 'refresh', intlKey: 'general.refresh', primary: true };

export const OSS_DIALOGS_DATA_MAP = {
  [DISCONNECTED_FOR_INACTIVITY_DIALOG]: {
    titleIntlKey: disconnectedForInactivityIntlKeys.title,
    messageIntlKey: disconnectedForInactivityIntlKeys.message,
    buttons: [
      { action: 'reconnect', intlKey: disconnectedForInactivityIntlKeys.reconnectLabel, primary: true },
      homeButton,
    ],
    analyticsEvent: DISCONNECT_CLICK,
  },
  [LOW_BALANCE_DIALOG]: {
    titleIntlKey: lowBalanceIntlKeys.title,
    messageIntlKey: lowBalanceIntlKeys.message,
    buttons: [
      { action: 'close', intlKey: lowBalanceIntlKeys.closeLabel, primary: false },
      { action: 'cashier', intlKey: lowBalanceIntlKeys.cashierLabel, primary: true },
    ],
  },
  [TABLE_CLOSED_DIALOG]: {
    titleIntlKey: tableClosedIntlKeys.title,
    messageIntlKey: tableClosedIntlKeys.message,
    buttons: [ homeButton ],
  },
  [NO_VIDEO_DIALOG]: {
    titleIntlKey: noVideoIntlKeys.title,
    messageIntlKey: noVideoIntlKeys.message,
    buttons: [
      refreshButton,
      homeButton,
    ],
  },
  [VIDEO_ERROR_DIALOG]: {
    titleIntlKey: videoErrorIntlKeys.title,
    messageIntlKey: videoErrorIntlKeys.message,
    buttons: [
      { action: 'continueWithoutVideo', intlKey: videoErrorIntlKeys.continueLabel, primary: false },
      refreshButton,
    ],
  },
};

export const DIALOGS_DISPLAYED_VIA_OSS_WRAPPER = Object.keys(OSS_DIALOGS_DATA_MAP);
/**
 * For the dialogs above, we send postMessage events and render them via Evo's Wrapper
 * For the dialogs below, we do not render them at all, neither do we send events for the Evo Wrapper to render them
 *  (they have a counter part which is rendered by Evo and we are using that)
 */
export const DIALOGS_NOT_RENDERED_IN_OSS = [ DISCONNECTED_SESSION_DIALOG ];
